module.exports = __webpack_public_path__ + "static/media/model.9be2864f.png";